module.exports = __webpack_public_path__ + "img/hero-shape-9.964b0ed4.png";